// extracted by mini-css-extract-plugin
export var centerAlign = "IconLinks-module--centerAlign--fcb3c";
export var checkIcon = "IconLinks-module--checkIcon--dbef4";
export var checkItem = "IconLinks-module--checkItem--33ea3";
export var checkLink = "IconLinks-module--checkLink--0552e";
export var connector = "IconLinks-module--connector--5f9dd";
export var container = "IconLinks-module--container--b39f7";
export var content = "IconLinks-module--content--d0591";
export var contentItem = "IconLinks-module--contentItem--b0b7d";
export var customStyle = "IconLinks-module--customStyle--0bd73";
export var from = "IconLinks-module--from--8df6f";
export var icon = "IconLinks-module--icon--5c3ff";
export var img = "IconLinks-module--img--42308";
export var item = "IconLinks-module--item--5b328";
export var label = "IconLinks-module--label--c8496";
export var link = "IconLinks-module--link--5d711";
export var message = "IconLinks-module--message--88136";
export var paragraph = "IconLinks-module--paragraph--7f2c6";
export var paragraphNoIcon = "IconLinks-module--paragraphNoIcon--ad92b";
export var price = "IconLinks-module--price--f15b6";
export var pricing = "IconLinks-module--pricing--a1f86";
export var sectionPricing = "IconLinks-module--sectionPricing--bfc28";
export var tile = "IconLinks-module--tile--5ad48";
export var tilePricing = "IconLinks-module--tilePricing--d85f6";
export var title = "IconLinks-module--title--08083";
export var to = "IconLinks-module--to--ad96d";